/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserDtoFromJSON, UserDtoToJSON, } from './UserDto.js';
import { ConnectionStatusFromJSON, ConnectionStatusToJSON, } from './ConnectionStatus.js';
import { IntegrationTypeFromJSON, IntegrationTypeToJSON, } from './IntegrationType.js';
/**
 * Check if a given object implements the IntegrationConnectionDto interface.
 */
export function instanceOfIntegrationConnectionDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
export function IntegrationConnectionDtoFromJSON(json) {
    return IntegrationConnectionDtoFromJSONTyped(json, false);
}
export function IntegrationConnectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': IntegrationTypeFromJSON(json['type']),
        'status': ConnectionStatusFromJSON(json['status']),
        'createdBy': UserDtoFromJSON(json['createdBy']),
        'createdAt': (new Date(json['createdAt'])),
        'lastSyncAt': json['lastSyncAt'] == null ? undefined : (new Date(json['lastSyncAt'])),
    };
}
export function IntegrationConnectionDtoToJSON(json) {
    return IntegrationConnectionDtoToJSONTyped(json, false);
}
export function IntegrationConnectionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': IntegrationTypeToJSON(value['type']),
        'status': ConnectionStatusToJSON(value['status']),
        'createdBy': UserDtoToJSON(value['createdBy']),
        'createdAt': ((value['createdAt']).toISOString()),
        'lastSyncAt': value['lastSyncAt'] === null ? null : (value['lastSyncAt']?.toISOString()),
    };
}
